import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { BathroomRepair } from 'landings/bathroom-repair';
import { RemoteProps } from './widgets-types';

export const BathroomRepairRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <BathroomRepair />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
